if (typeof ShippingCalculator !== 'function') {

  class ShippingCalculator extends HTMLElement {

    constructor() {
      super();

      const estimateShipping = this.querySelector('.js-estimate-shipping');
      const country = this.querySelector('[name="country"]');
      const province = this.querySelector('[name="province"]');
      const zip = this.querySelector('[name="zip"]');
      const resultsBlock = this.querySelector('.shipping-estimator__results');
      const resultsBlockContent = this.querySelector('.shipping-estimator__results-content');
      const resultsBlockContentList = this.querySelector('.shipping-estimator__results-content ul');
      const resultsBlockContentHeading = this.querySelector('.shipping-estimator__results-content-heading');
      const resultsErrors = this.querySelector('.alert');

      setTimeout(() => {
        new Shopify.CountryProvinceSelector(
          'shipping-estimator-country',
          'shipping-estimator-province',
          { hideElement: 'address_province_container' }
        );
      });

    
      estimateShipping.addEventListener('click', (e) => {
        e.preventDefault();

        resultsBlockContentList.innerHTML = "";

        const selectedCountry = country.value.trim().toLowerCase();
        const zipValue = zip.value.trim();
 
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {

            const cartTotal = cart.total_price; 
 
            if (selectedCountry === 'singapore' && zipValue === '') {

              let shippingFee = 0;
              let label = '';

              if (cartTotal >= 20000) {
                shippingFee = 0;
                label = 'Free Delivery';
              } else if (cartTotal >= 18000) {
                shippingFee = 1000;
                label = 'Delivery Fee';
              } else {
                shippingFee = 2500;
                label = 'Delivery Fee';
              }

              resultsErrors.style.display = "none";
              resultsBlock.style.display = "block";
              resultsBlockContent.style.display = "block";
              resultsBlockContentHeading.innerHTML = "Estimated Shipping";

              resultsBlockContentList.innerHTML = `
                <li>
                  ${label}:
                  ${shippingFee === 0
                    ? 'FREE'
                    : this._formatMoney(shippingFee, KROWN.settings.shop_money_format)}
                  <small style="display:block;opacity:.7">
                    * Final delivery fee calculated at checkout
                  </small>
                </li>
              `;

              return;  
            }
 
            fetch(
              KROWN.settings.routes.cart_url +
              '/shipping_rates.json?shipping_address[zip]=' + zip.value +
              '&shipping_address[country]=' + country.value +
              '&shipping_address[province]=' + province.value,
              {
                credentials: 'same-origin',
                method: 'GET'
              }
            )
              .then(r => r.json())
              .then(result => {

                if (result.country || result.zip) {

                  resultsBlockContent.style.display = "none";
                  resultsBlock.style.display = "block";
                  resultsErrors.style.display = "block";
                  resultsErrors.innerHTML = "";

                  Object.keys(result).forEach(key => {
                    resultsErrors.innerHTML += `<li>${result[key]}</li>`;
                  });

                } else {

                  const rates = Object.keys(result.shipping_rates);

                  resultsErrors.style.display = "none";
                  resultsBlock.style.display = "block";
                  resultsBlockContent.style.display = "block";
                  resultsBlockContentHeading.innerHTML =
                    KROWN.settings.locales.shipping_calculator_results_heading_one;

                  rates.forEach(key => {
                    resultsBlockContentList.innerHTML +=
                      `<li>${result.shipping_rates[key].presentment_name}: 
                      ${this._formatMoney(result.shipping_rates[key].price, KROWN.settings.shop_money_format)}
                      </li>`;
                  });
                }
              });

          });
      });

      country.addEventListener('change', () => {
        resultsBlock.style.display = "none";
      });
    }
 
    _formatMoney(cents, format) {

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  if (typeof customElements.get('shipping-calculator') === 'undefined') {
    customElements.define('shipping-calculator', ShippingCalculator);
  }
}
